<template>
  <v-navigation-drawer
    id="app-drawer"
    app
    dark
    floating
    persistent
    mobile-break-point="960"
    width="260"
    color="#ffffff"
    :expand-on-hover="true"
    :mini-variant.sync="mini"
  >
    <v-layout tag="v-list" column>
      <v-list-item-title avatar height="24" class="" style="margin-top: -20px">
        <v-list-item-title color="white">
          <v-img height="12" contain />
        </v-list-item-title>
        <v-list-item class="title  blue-grey--text">
          <v-list-item-avatar class="mx-n2">
            <logo></logo>
          </v-list-item-avatar>
          <v-list-item>
            <!--                        <v-btn text icon @click.stop="mini = !mini" class="mx-n4"><v-icon dark>mdi-dots-vertical</v-icon></v-btn>-->
            <v-list-item-title class="mx-4 blue-grey--text"
              >Kyami Pay</v-list-item-title
            >
          </v-list-item>
        </v-list-item>
      </v-list-item-title>

      <!--                    <v-divider/>-->

      <!--        MENU-->
      <v-list :shaped="shaped" :nav="nav">
        <v-list-item-group v-model="item" color="primary pink--text">
          <v-list-item
            v-for="(item, i) in items"
            :key="i"
            :to="item.link"
            v-show="item.value"
          >
            <v-list-item-icon>
              <v-icon v-text="item.icon" color="#625f6e"></v-icon>
            </v-list-item-icon>
            <v-list-item-content style="color: #625f6e;">
              <v-list-item-title
                v-html="item.title"
                class="subtitle-2 font-weight-regular"
              ></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-layout>
  </v-navigation-drawer>
</template>

<script>
import eventBus from "../../main";
import Logo from "../logo/Logo";
import jwtDecode from "jwt-decode";
import store from "../../store";

export default {
  components: { Logo },
  data: () => ({
    shaped: false,
    nav: false,
    avatar: true,
    mini: false,
    drawer: false,
    item: 0,

    security: {
      icon: "mdi-shield-lock",
      title: "Segurança",
      link: "/help/center",
      value: true
    },
    wallet: {
      icon: "mdi-wallet",
      title: "Carteira",
      value: true
    },

    items: [
      {
        icon: "mdi-tablet-dashboard",
        title: "Resumo",
        link: "/console",
        value: store.getters.getDrawerPersonal === store.getters.getRefusion
      },
      {
        // icon: "mdi-ballot",
        icon: "mdi-credit-card-outline",
        title: "Pagamentos",
        link: "/entity",
        value: store.getters.getDrawerPersonal === store.getters.getRefusion
      },
      {
        icon: "mdi-account",
        title: "Perfil",
        link: "/account/profile",
        value: store.getters.getDrawerPersonal === store.getters.getRefusion
      },
      // {
      //   icon: "mdi-wallet",
      //   title: "Carteira",
      //   link: "/account/wallet",
      //   value: store.getters.getDrawerPersonal === store.getters.getRefusion
      // },
      {
        icon: "mdi-format-list-text",
        title: "Transações",
        link: "/account/transactions",
        value: store.getters.getDrawerPersonal === store.getters.getRefusion
      },
      {
        icon: "mdi-cog-outline",
        title: "Definições",
        link: "/account/config",
        value: store.getters.getDrawerPersonal === store.getters.getRefusion
      }
    ]
  }),
  methods: {
    openRemoveCard() {
      eventBus.$emit("openSecurity", true); // emit the event to the bus
    },
    openWallet() {
      eventBus.$emit("openWallet", true); // emit the event to the bus
    }
  },
  created() {
    const self = this;
    eventBus.$on("eventDrawClient", function(value) {
      self.mini = value;
    });
  },
  beforeCreate() {
    const userToken = localStorage.getItem("token");
    const decode = jwtDecode(userToken);
    let startWith = decode.Pub;
    store.dispatch("setDrawerPersonal", startWith.substr(0, 6));
  }
};
</script>

<style lang="scss">
.arrangeBottom {
  bottom: 5px;
  width: 100%;
  position: fixed;
}

.arrangeWaalet {
  margin-top: -16px;
}
/*color="blue-grey darken-4"*/
/*#app-drawer {*/
/*  .v-list__tile {*/
/*    border-radius: 4px;*/

/*    &--buy {*/
/*      margin-top: auto;*/
/*      margin-bottom: 17px;*/
/*    }*/
/*  }*/
/*}*/
</style>
